import { isJson } from './isJson';
import { safeParseWithDefault } from './stringHelpers';

export const ERROR_MESSAGES = {
  requiredField: 'This field is required.',
  validEmail: 'A valid email is required.',
  validMobile: 'A valid mobile number is required.',
};

/**
 * returns `true` if `REACT_APP_BOOKINGS_BRANDING=obee`
 */
export const isObee = process.env.REACT_APP_BOOKINGS_BRANDING === 'obee';

export const isObeeLogic = true;

export const companyName = isObee ? 'Obee' : 'EatClub';

export const daysOfWeekShort = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const daysOfWeekLongMap = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};
export const momentDaysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const disabledAccessMessage = {
  yes: 'Access Ramps & disabled facilities',
  no: 'No access ramps & disabled facilities',
  contact_us: 'Please contact us for more details',
};

export const dressCodeMessage = {
  no: 'No dress code',
  casual: 'No thongs or singlets permitted',
  smart_casual: 'Smart casual attire required for entry',
  formal: 'Formal attire required for entry',
};

export const childrensMenuMessage = {
  no: 'No kids menu available',
  yes: 'Kids menu available',
  contact_us: 'Please contact us for more details',
};

export const playAreaMessage = {
  no: 'No children’s play area onsite',
  yes: 'There is a children’s play area onsite',
  contact_us: 'Please contact us for more details',
};

export const byoMessage = (byoOption) => {
  const optionAsString = isJson(byoOption)
    ? Object.values(safeParseWithDefault(byoOption, {}))?.sort()?.join('_')
    : byoOption;

  return {
    beer: 'We have a BYO licence for beer only',
    wine: 'We have a BYO licence for wine only',
    beer_wine: 'We have a BYO licence for beer and wine',
    bar_service: 'No BYO, although we have a fully stocked bar!',
    unlicensed: 'Alcohol is not permitted onsite',
  }?.[optionAsString];
};

export const corkageMessage = (option, fee, perBottle) =>
  ({
    no: 'We don’t charge any corkage fees',
    yes: `Yes, we have a $${fee} corkage fee per ${perBottle ? 'bottle' : 'booking'}`,
    contact_us: 'Please contact us for more details',
  }?.[option]);

export const cakesMessage = {
  no: 'Unfortunately we can’t store cakes',
  yes: 'Yes, we can store cakes on arrival',
  contact_us: 'Please contact us for more details',
};
export const COUNTRY_CODES = [
  { name: 'Afghanistan', label: '+93' },
  { name: 'Albania', label: '+355' },
  { name: 'Algeria', label: '+213' },
  { name: 'American Samoa', label: '+1-684' },
  { name: 'Andorra', label: '+376' },
  { name: 'Angola', label: '+244' },
  { name: 'Anguilla', label: '+1-264' },
  { name: 'Antarctica', label: '+672' },
  { name: 'Antigua and Barbuda', label: '+1-268' },
  { name: 'Argentina', label: '+54' },
  { name: 'Armenia', label: '+374' },
  { name: 'Aruba', label: '+297' },
  { name: 'Australia', label: '+61' },
  { name: 'Austria', label: '+43' },
  { name: 'Azerbaijan', label: '+994' },
  { name: 'Bahamas', label: '+1-242' },
  { name: 'Bahrain', label: '+973' },
  { name: 'Bangladesh', label: '+880' },
  { name: 'Barbados', label: '+1-246' },
  { name: 'Belarus', label: '+375' },
  { name: 'Belgium', label: '+32' },
  { name: 'Belize', label: '+501' },
  { name: 'Benin', label: '+229' },
  { name: 'Bermuda', label: '+1-441' },
  { name: 'Bhutan', label: '+975' },
  { name: 'Bolivia', label: '+591' },
  { name: 'Bosnia and Herzegovina', label: '+387' },
  { name: 'Botswana', label: '+267' },
  { name: 'Brazil', label: '+55' },
  { name: 'British Indian Ocean Territory', label: '+246' },
  { name: 'British Virgin Islands', label: '+1-284' },
  { name: 'Brunei', label: '+673' },
  { name: 'Bulgaria', label: '+359' },
  { name: 'Burkina Faso', label: '+226' },
  { name: 'Burundi', label: '+257' },
  { name: 'Cambodia', label: '+855' },
  { name: 'Cameroon', label: '+237' },
  { name: 'Canada', label: '+1' },
  { name: 'Cape Verde', label: '+238' },
  { name: 'Cayman Islands', label: '+1-345' },
  { name: 'Central African Republic', label: '+236' },
  { name: 'Chad', label: '+235' },
  { name: 'Chile', label: '+56' },
  { name: 'China', label: '+86' },
  { name: 'Christmas Island', label: '+61' },
  { name: 'Cocos Islands', label: '+61' },
  { name: 'Colombia', label: '+57' },
  { name: 'Comoros', label: '+269' },
  { name: 'Cook Islands', label: '+682' },
  { name: 'Costa Rica', label: '+506' },
  { name: 'Croatia', label: '+385' },
  { name: 'Cuba', label: '+53' },
  { name: 'Curacao', label: '+599' },
  { name: 'Cyprus', label: '+357' },
  { name: 'Czech Republic', label: '+420' },
  { name: 'Democratic Republic of the Congo', label: '+243' },
  { name: 'Denmark', label: '+45' },
  { name: 'Djibouti', label: '+253' },
  { name: 'Dominica', label: '+1-767' },
  { name: 'Dominican Republic', label: '+1-809' },
  { name: 'East Timor', label: '+670' },
  { name: 'Ecuador', label: '+593' },
  { name: 'Egypt', label: '+20' },
  { name: 'El Salvador', label: '+503' },
  { name: 'Equatorial Guinea', label: '+240' },
  { name: 'Eritrea', label: '+291' },
  { name: 'Estonia', label: '+372' },
  { name: 'Eswatini', label: '+268' },
  { name: 'Ethiopia', label: '+251' },
  { name: 'Falkland Islands', label: '+500' },
  { name: 'Faroe Islands', label: '+298' },
  { name: 'Fiji', label: '+679' },
  { name: 'Finland', label: '+358' },
  { name: 'France', label: '+33' },
  { name: 'French Polynesia', label: '+689' },
  { name: 'Gabon', label: '+241' },
  { name: 'Gambia', label: '+220' },
  { name: 'Georgia', label: '+995' },
  { name: 'Germany', label: '+49' },
  { name: 'Ghana', label: '+233' },
  { name: 'Gibraltar', label: '+350' },
  { name: 'Greece', label: '+30' },
  { name: 'Greenland', label: '+299' },
  { name: 'Grenada', label: '+1-473' },
  { name: 'Guam', label: '+1-671' },
  { name: 'Guatemala', label: '+502' },
  { name: 'Guernsey', label: '+44-1481' },
  { name: 'Guinea', label: '+224' },
  { name: 'Guinea-Bissau', label: '+245' },
  { name: 'Guyana', label: '+592' },
  { name: 'Haiti', label: '+509' },
  { name: 'Honduras', label: '+504' },
  { name: 'Hong Kong', label: '+852' },
  { name: 'Hungary', label: '+36' },
  { name: 'Iceland', label: '+354' },
  { name: 'India', label: '+91' },
  { name: 'Indonesia', label: '+62' },
  { name: 'Iran', label: '+98' },
  { name: 'Iraq', label: '+964' },
  { name: 'Ireland', label: '+353' },
  { name: 'Isle of Man', label: '+44-1624' },
  { name: 'Israel', label: '+972' },
  { name: 'Italy', label: '+39' },
  { name: 'Ivory Coast', label: '+225' },
  { name: 'Jamaica', label: '+1-876' },
  { name: 'Japan', label: '+81' },
  { name: 'Jersey', label: '+44-1534' },
  { name: 'Jordan', label: '+962' },
  { name: 'Kazakhstan', label: '+7' },
  { name: 'Kenya', label: '+254' },
  { name: 'Kiribati', label: '+686' },
  { name: 'Kosovo', label: '+383' },
  { name: 'Kuwait', label: '+965' },
  { name: 'Kyrgyzstan', label: '+996' },
  { name: 'Laos', label: '+856' },
  { name: 'Latvia', label: '+371' },
  { name: 'Lebanon', label: '+961' },
  { name: 'Lesotho', label: '+266' },
  { name: 'Liberia', label: '+231' },
  { name: 'Libya', label: '+218' },
  { name: 'Liechtenstein', label: '+423' },
  { name: 'Lithuania', label: '+370' },
  { name: 'Luxembourg', label: '+352' },
  { name: 'Macau', label: '+853' },
  { name: 'Macedonia', label: '+389' },
  { name: 'Madagascar', label: '+261' },
  { name: 'Malawi', label: '+265' },
  { name: 'Malaysia', label: '+60' },
  { name: 'Maldives', label: '+960' },
  { name: 'Mali', label: '+223' },
  { name: 'Malta', label: '+356' },
  { name: 'Marshall Islands', label: '+692' },
  { name: 'Mauritania', label: '+222' },
  { name: 'Mauritius', label: '+230' },
  { name: 'Mayotte', label: '+262' },
  { name: 'Mexico', label: '+52' },
  { name: 'Micronesia', label: '+691' },
  { name: 'Moldova', label: '+373' },
  { name: 'Monaco', label: '+377' },
  { name: 'Mongolia', label: '+976' },
  { name: 'Montenegro', label: '+382' },
  { name: 'Montserrat', label: '+1-664' },
  { name: 'Morocco', label: '+212' },
  { name: 'Mozambique', label: '+258' },
  { name: 'Myanmar', label: '+95' },
  { name: 'Namibia', label: '+264' },
  { name: 'Nauru', label: '+674' },
  { name: 'Nepal', label: '+977' },
  { name: 'Netherlands', label: '+31' },
  { name: 'Netherlands Antilles', label: '+599' },
  { name: 'New Caledonia', label: '+687' },
  { name: 'New Zealand', label: '+64' },
  { name: 'Nicaragua', label: '+505' },
  { name: 'Niger', label: '+227' },
  { name: 'Nigeria', label: '+234' },
  { name: 'Niue', label: '+683' },
  { name: 'Norfolk Island', label: '+672' },
  { name: 'North Korea', label: '+850' },
  { name: 'Northern Mariana Islands', label: '+1-670' },
  { name: 'Norway', label: '+47' },
  { name: 'Oman', label: '+968' },
  { name: 'Pakistan', label: '+92' },
  { name: 'Palau', label: '+680' },
  { name: 'Palestine', label: '+970' },
  { name: 'Panama', label: '+507' },
  { name: 'Papua New Guinea', label: '+675' },
  { name: 'Paraguay', label: '+595' },
  { name: 'Peru', label: '+51' },
  { name: 'Philippines', label: '+63' },
  { name: 'Poland', label: '+48' },
  { name: 'Portugal', label: '+351' },
  { name: 'Puerto Rico', label: '+1-787' },
  { name: 'Qatar', label: '+974' },
  { name: 'Republic of the Congo', label: '+242' },
  { name: 'Romania', label: '+40' },
  { name: 'Russia', label: '+7' },
  { name: 'Rwanda', label: '+250' },
  { name: 'Saint Barthelemy', label: '+590' },
  { name: 'Saint Helena', label: '+290' },
  { name: 'Saint Kitts and Nevis', label: '+1-869' },
  { name: 'Saint Lucia', label: '+1-758' },
  { name: 'Saint Martin', label: '+590' },
  { name: 'Saint Pierre and Miquelon', label: '+508' },
  { name: 'Saint Vincent and the Grenadines', label: '+1-784' },
  { name: 'Samoa', label: '+685' },
  { name: 'San Marino', label: '+378' },
  { name: 'Sao Tome and Principe', label: '+239' },
  { name: 'Saudi Arabia', label: '+966' },
  { name: 'Senegal', label: '+221' },
  { name: 'Serbia', label: '+381' },
  { name: 'Seychelles', label: '+248' },
  { name: 'Sierra Leone', label: '+232' },
  { name: 'Singapore', label: '+65' },
  { name: 'Sint Maarten', label: '+1-721' },
  { name: 'Slovakia', label: '+421' },
  { name: 'Slovenia', label: '+386' },
  { name: 'Solomon Islands', label: '+677' },
  { name: 'Somalia', label: '+252' },
  { name: 'South Africa', label: '+27' },
  { name: 'South Korea', label: '+82' },
  { name: 'South Sudan', label: '+211' },
  { name: 'Spain', label: '+34' },
  { name: 'Sri Lanka', label: '+94' },
  { name: 'Sudan', label: '+249' },
  { name: 'Suriname', label: '+597' },
  { name: 'Svalbard and Jan Mayen', label: '+47' },
  { name: 'Swaziland', label: '+268' },
  { name: 'Sweden', label: '+46' },
  { name: 'Switzerland', label: '+41' },
  { name: 'Syria', label: '+963' },
  { name: 'Taiwan', label: '+886' },
  { name: 'Tajikistan', label: '+992' },
  { name: 'Tanzania', label: '+255' },
  { name: 'Thailand', label: '+66' },
  { name: 'Timor-Leste', label: '+670' },
  { name: 'Togo', label: '+228' },
  { name: 'Tokelau', label: '+690' },
  { name: 'Tonga', label: '+676' },
  { name: 'Trinidad and Tobago', label: '+1-868' },
  { name: 'Tunisia', label: '+216' },
  { name: 'Turkey', label: '+90' },
  { name: 'Turkmenistan', label: '+993' },
  { name: 'Turks and Caicos Islands', label: '+1-649' },
  { name: 'Tuvalu', label: '+688' },
  { name: 'Uganda', label: '+256' },
  { name: 'Ukraine', label: '+380' },
  { name: 'United Arab Emirates', label: '+971' },
  { name: 'United Kingdom', label: '+44' },
  { name: 'United States', label: '+1' },
  { name: 'Uruguay', label: '+598' },
  { name: 'Uzbekistan', label: '+998' },
  { name: 'Vanuatu', label: '+678' },
  { name: 'Vatican', label: '+379' },
  { name: 'Venezuela', label: '+58' },
  { name: 'Vietnam', label: '+84' },
  { name: 'Wallis and Futuna', label: '+681' },
  { name: 'Western Sahara', label: '+212' },
  { name: 'Yemen', label: '+967' },
  { name: 'Zambia', label: '+260' },
  { name: 'Zimbabwe', label: '+263' },
];
